import React, { useState } from 'react'

import Account from './tabs/Account'
import UITabBar from '../../../components/UI/UITabBar'
import { Icon } from '../../../components/Icon'
import { useAuth } from '../../../context/AuthContext'

const CandidateSettings = () => {
  const [activeTab, setActiveTab] = useState<string>('Account')
  const { logout } = useAuth()

  const handlePressTab = (tab: string) => {
    setActiveTab(tab)
  }

  return (
    <div
      className={
        'flex flex-col gap-20 w-full bg-white  h-full rounded-3xl p-5 '
      }
    >
      <div
        style={{
          height: 'calc(100vh - 100px)',
          overflow: 'auto',
          scrollbarWidth: 'none',
        }}
      >
        <div className={'flex w-full justify-between items-start '}>
          <div className="flex-col w-[50%] gap-[20px]">
            <p className={'text-lg leading-6 text-text2 font-bold'}>Settings</p>
          </div>
          <div
            onClick={() => logout()}
            className="gap-[10px]  bg-gray2 items-center justify-between min-w-[95px] text-white h-12 px-[20px] flex rounded-[72px] cursor-pointer"
          >
            <p className={'font-semibold text-sm text-text1 leading-6'}>
              Logout
            </p>
            <Icon
              name={'IconLogout'}
              strokeWidth={1}
              stroke={'#3487A2'}
              width={16}
              height={16}
            />
          </div>
        </div>
        <UITabBar
          titles={['Account']}
          activeTab={activeTab}
          onPressTab={handlePressTab}
          containerStyle="mt-4"
          activeTabText="text-text2"
        />
        {activeTab == 'Account' && <Account />}
      </div>
    </div>
  )
}

export default CandidateSettings
